import * as Sentry from '@sentry/remix';

import { ensurePixelIsLoaded } from '~/utils/pixels';

export async function fireEvent(eventName: string, data?: unknown) {
  try {
    if (!(await ensurePixelIsLoaded('ttq'))) return;

    window.ttq.track(eventName, data);
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: 'Failed to fire TikTok pixel event' }
    });
  }
}

export default {
  fireEvent
};
